import OverviewConfig from './overview/OverviewConfig';
import { Navigate } from 'react-router-dom';
import i18next from 'i18next';
import enGB from '@locales/persomat/enGB';
import deAT from '@locales/persomat/deAT';

i18next.addResourceBundle('enGB', 'persomat', enGB);
i18next.addResourceBundle('deAT', 'persomat', deAT);

const PersomatConfigs = [
	OverviewConfig,
	{
		routes: [
			{
				path: '/pm',
				exact: true,
				element: <Navigate to="/pm/overview" />,
			}
		]
	}
];

export default PersomatConfigs;
